const KEY = 'ROLE';

export { KEY };
